// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"TextboxModal_modalWrap__1XlH1","buttonWrap":"TextboxModal_buttonWrap__2qt9A","textAreaWrap":"TextboxModal_textAreaWrap__3TOiX"};